var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"30px"}},[_c('div',{staticStyle:{"margin":"20px"}},[_vm._v(" \n          欢迎来到 清河素养协同共育 后台管理系统!\n          ")])])}]

export { render, staticRenderFns }